import React from 'react';

const PrivacyPolicy: React.FC = () => {

  return (
    <>
			<strong>Privacy Policy</strong>
      <br></br>
			<p>
				Our Privacy Policy was last updated and posted on June 23, 2021. It
				governs the privacy terms of our App, located at https://ElevenEagles.tech,
				sub-domains, and any associated web-based and mobile applications
				(collectively, &quot;App&quot;), as owned and operated by ElevenEagles. Any
				capitalized terms not defined in our Privacy Policy, have the meaning as
				specified in our Terms of Service.
			</p>
			<p>
				Your privacy is very important to us. Accordingly, we have developed
				this Policy in order for you to understand how we collect, use,
				communicate and disclose and make use of personal information. We use
				your Personal Information only for providing and improving the App. By
				using the App, you agree to the collection and use of information in
				accordance with this policy. Unless otherwise defined in this Privacy
				Policy, terms used in this Privacy Policy have the same meanings as in
				our Terms and Conditions, accessible at https://ElevenEagles.tech. The
				following outlines our privacy policy.
			</p>
			<ul>
				<li>
					Before or at the time of collecting personal information, we will
					identify the purposes for which information is being collected.
				</li>
				<li>
					We will collect and use personal information solely with the objective
					of fulfilling those purposes specified by us and for other compatible
					purposes, unless we obtain the consent of the individual concerned or
					as required by law.
				</li>
				<li>
					We will only retain personal information as long as necessary for the
					fulfillment of those purposes.
				</li>
				<li>
					We will collect personal information by lawful and fair means and,
					where appropriate, with the knowledge or consent of the individual
					concerned.
				</li>
				<li>
					Personal data should be relevant to the purposes for which it is to be
					used, and, to the extent necessary for those purposes, should be
					accurate, complete, and up-to-date.
				</li>
				<li>
					We will protect personal information by reasonable security safeguards
					against loss or theft, as well as unauthorized access, disclosure,
					copying, use or modification.
				</li>
				<li>
					We will make readily available to customers information about our
					policies and practices relating to the management of personal
					information.
				</li>
			</ul>

			<p>
				<strong>Your Privacy</strong>
				<br />
				ElevenEagles follows all legal requirements to protect your privacy. Our
				Privacy Policy is a legal statement that explains how we may collect
				information from you, how we may share your information, and how you can
				limit our sharing of your information. We utilize the Personal Data you
				offer in a way that is consistent with this Personal privacy Policy. If
				you provide Personal Data for a particular reason, we could make use of
				the Personal Data in connection with the reason for which it was
				provided. For example, registration info sent when developing your
				account, might be used to suggest products to you based on past
				acquisitions. We might use your Personal Data to offer access to
				services on the App and monitor your use of such services. ElevenEagles may
				also utilize your Personal Data and various other personally
				non-identifiable info gathered through the App to assist us with
				improving the material and functionality of the App, to much better
				comprehend our users, and to improve our services. You will see terms in
				our Privacy Policy that are capitalized. These terms have meanings as
				described in the Definitions section below.
			</p>

			<p>
				<strong>Definitions</strong>
				<br />
				"Non Personal Information" is information that is not personally
				identifiable to you and that we automatically collect when you access
				our App with a web browser. It may also include publicly available
				information that is shared between you and others.
			</p>
			<p>
				"Personally Identifiable Information" is non-public information that is
				personally identifiable to you and obtained in order for us to provide
				you our App. Personally Identifiable Information may include information
				such as your name, email address, and other related information that you
				provide to us or that we obtain about you.
			</p>

			<p>
				<strong>Information We Collect</strong>
				<br />
				Generally, you control the amount and type of information you provide to
				us when using our App.
			</p>
			<p>
				As a Visitor, you can browse our App to find out more about our App. You
				are not required to provide us with any Personally Identifiable
				Information as a Visitor.
			</p>

			<p>
				<strong>Computer Information Collected</strong>
				<br />
				When you use our App, we automatically collect certain computer
				information by the interaction of your mobile phone or web browser with
				our App. Such information is typically considered Non Personal
				Information. We also collect the following:
			</p>
			<ul>
				<li>
					<p>
						<strong>Cookies</strong>
						<br />
						Our App uses "Cookies" to identify the areas of our App that you
						have visited. A Cookie is a small piece of data stored on your
						computer or mobile device by your web browser. We use Cookies to
						personalize the Content that you see on our App. Most web browsers
						can be set to disable the use of Cookies. However, if you disable
						Cookies, you may not be able to access functionality on our App
						correctly or at all. We never place Personally Identifiable
						Information in Cookies.
					</p>
				</li>
				<li>
					<strong>Geographical Information</strong>
					<br />
					When you use the mobile application, we may use GPS technology (or
					other similar technology) to determine your current location in order
					to determine the city you are located in and display information with
					relevant data or advertisements. We will not share your current
					location with other users or partners. If you do not want us to use
					your location for the purposes set forth above, you should turn off
					the location services for the mobile application located in your
					account settings or in your mobile phone settings and/or within the
					mobile application.
					<br />
					<br />
				</li>
				<li>
					<strong>Automatic Information</strong>
					<br />
					We automatically receive information from your web browser or mobile
					device. This information includes the name of the App from which you
					entered our App, if any, as well as the name of the App to which
					you're headed when you leave our App. This information also includes
					the IP address of your computer/proxy server that you use to access
					the Internet, your Internet App provider name, web browser type, type
					of mobile device, and computer operating system. We use all of this
					information to analyze trends among our Users to help improve our App.
					<br />
					<br />
				</li>
				<li>
					<strong>Log Data</strong>
					<br />
					Like many App operators, we collect information that your browser
					sends whenever you visit our App (&quot;Log Data&quot;). This Log Data
					may include information such as your computer's Internet Protocol
					(&quot;IP&quot;) address, browser type, browser version, the pages of
					our App that you visit, the time and date of your visit, the time
					spent on those pages and other statistics.{' '}
				</li>
			</ul>
			<p>
				Under the Child's Online Privacy Security Act, no App operator can
				require, as a condition to involvement in an activity, that a child
				younger than 13 years of age divulge more details than is reasonably
				required. ElevenEagles abides by this demand. ElevenEagles just collects information
				willingly offered; no information is gathered passively. children under
				13 can submit only their email address when sending us an email in our
				&quot;Contact Us&quot; area. ElevenEagles makes use of the email address to
				respond to a one-time demand from a child under 13 and afterwards
				deletes the email address. In case ElevenEagles collects and maintains
				personal information relating to a child under 13, the parent may send
				out an email to us to review, alter and/or erase such info as well as to
				decline to enable any additional collection or use of the child's
				information.
			</p>

			<p>
				<strong>How We Use Your Information</strong>
				<br />
				We use the information we receive from you as follows:
			</p>
			<ul>
				<li>
					<p>
						<strong>Customizing Our App</strong>
						<br />
						We may use the Personally Identifiable information you provide to us
						along with any computer information we receive to customize our App.
					</p>
				</li>
				<li>
					<p>
						<strong>
							Sharing Information with Affiliates and Other Third Parties
						</strong>
						<br />
						We do not sell, rent, or otherwise provide your Personally
						Identifiable Information to third parties for marketing purposes. We
						may provide your Personally Identifiable Information to affiliates
						that provide services to us with regards to our App (i.e. payment
						processors, App hosting companies, etc.); such affiliates will only
						receive information necessary to provide the respective services and
						will be bound by confidentiality agreements limiting the use of such
						information.
					</p>
				</li>
				<li>
					<p>
						<strong>Data Aggregation</strong>
						<br />
						We retain the right to collect and use any Non Personal Information
						collected from your use of our App and aggregate such data for
						internal analytics that improve our App and Service as well as for
						use or resale to others. At no time is your Personally Identifiable
						Information included in such data aggregations.
					</p>
				</li>
				<li>
					<p>
						<strong>Legally Required Releases of Information</strong>
						<br />
						We may be legally required to disclose your Personally Identifiable
						Information, if such disclosure is (a) required by subpoena, law, or
						other legal process; (b) necessary to assist law enforcement
						officials or government enforcement agencies; (c) necessary to
						investigate violations of or otherwise enforce our Legal Terms; (d)
						necessary to protect us from legal action or claims from third
						parties including you and/or other Members; and/or (e) necessary to
						protect the legal rights, personal/real property, or personal safety
						of ElevenEagles, our Users, employees, and affiliates.
					</p>
				</li>
			</ul>
			<p>
				<strong> Opt-Out</strong>
				<br />
				We offer you the chance to "opt-out" from having your personally
				identifiable information used for particular functions, when we ask you
				for this detail. When you register for the App, if you do not want to
				receive any additional material or notifications from us, you can show
				your preference on our registration form.
			</p>
			<p>
				<strong>Links to Other Apps</strong>
				<br />
				Our App may contain links to other Apps that are not under our direct
				control. These Apps may have their own policies regarding privacy. We
				have no control of or responsibility for linked Apps and provide these
				links solely for the convenience and information of our visitors. You
				access such linked Apps at your own risk. These Apps are not subject to
				this Privacy Policy. You should check the privacy policies, if any, of
				those individual Apps to see how the operators of those third-party Apps
				will utilize your personal information. In addition, these Apps may
				contain a link to Apps of our affiliates. The Apps of our affiliates are
				not subject to this Privacy Policy, and you should check their
				individual privacy policies to see how the operators of such Apps will
				utilize your personal information.
			</p>
			<p>
				<strong>Security</strong>
				<br />
				The security of your Personal Information is important to us, but
				remember that no method of transmission over the Internet, or method of
				electronic storage, is 100% secure. While we strive to use commercially
				acceptable means to protect your Personal Information, we cannot
				guarantee its absolute security. We utilize practical protection
				measures to safeguard against the loss, abuse, and modification of the
				individual Data under our control. Personal Data is kept in a secured
				database and always sent out by means of an encrypted SSL method when
				supported by your web browser. No Web or email transmission is ever
				totally protected or mistake cost-free. For example, email sent out to
				or from the App may not be protected. You must take unique care in
				deciding what info you send to us by means of email.
			</p>

			<p>
				<strong>Privacy Policy Updates</strong>
				<br />
				We reserve the right to modify this Privacy Policy at any time. You
				should review this Privacy Policy frequently. If we make material
				changes to this policy, we may notify you on our App, by a blog post, by
				email, or by any method we determine. The method we chose is at our sole
				discretion. We will also change the "Last Updated" date at the beginning
				of this Privacy Policy. Any changes we make to our Privacy Policy are
				effective as of this Last Updated date and replace any prior Privacy
				Policies.
			</p>

			<p>
				<strong>
					Questions About Our Privacy Practices or This Privacy Policy
				</strong>
				<br />
				We are committed to conducting our business in accordance with these
				principles in order to ensure that the confidentiality of personal
				information is protected and maintained. If you have any questions about
				our Privacy Practices or this Policy, please contact us.
			</p>
		</>
  );
};

export default PrivacyPolicy;
